import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import "../../../public/assets/css/ontario-design-system/styles/components/tables/tables.css"
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import "../../../public/assets/css/hover.css"
import { CheckStatus } from "../../entities/Constants";
import { getRootComponent } from "../../utilities/ElementUtils";
import IRPStatusTable from "../subDataTable/IRPStatusTable";
interface Props {
  isEng: boolean;
  field: FormSectionElements;
  callbackElement
}

interface State {

  isHovered: boolean
}
export class DataTableComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
    this.state = {
      isHovered: false,
    };
    let field = this.props.field;
    this.handleMouseClick = this.handleMouseClick.bind(this);
    FormValidationUtils.runJavascript(field);
  }

  componentDidMount(): void {
    window.addEventListener('click', this.handleMouseClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleMouseClick);
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    // the code for fixing the accessibility issues
    const dataTable = document.getElementById(`data-table-${this.props.field.Id}`);
    if (dataTable) {
      const table = dataTable.getElementsByTagName('table')?.[0];
      if (table) {
        table.removeAttribute('role');
        table.querySelector('thead')?.removeAttribute('role');
        table.querySelector('tbody')?.removeAttribute('role');
        table.querySelectorAll('thead tr')?.forEach((element) => element.removeAttribute('role'));
        table.querySelectorAll('tbody tr')?.forEach((element) => element.removeAttribute('role'));
        table.querySelectorAll('tbody td')?.forEach((element) => element.removeAttribute('role'));
        table.querySelectorAll('thead th')?.forEach((element) => {
          element.removeAttribute('role');
          element.setAttribute('scope', 'col');
        });
      }
    }
  }

  handleMouseClick = (e) => {
    let node = e.target ;
    const tag = e.target.tagName;
    if (node && node.nodeName) {
      console.log("node name:", node.nodeName)
    }
    if (tag!== 'svg' && tag!== 'use') {
      this.setState({ isHovered: false });
      return
    }

    do {
      if (node.id === `alert-info-icon-${this.props.field.Id}`) {
        this.setState({ isHovered: true });
        break;
      }
      node = node.parentNode;
    } while (node);

    if (!node) {
      this.setState({ isHovered: false });
    } 
  }

  handleMouseEnter = () => {
    console.log("Mouse Enter Triggered");
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    console.log("Mouse Leave Triggered");
      this.setState({ isHovered: false });
  };
  render() {
    const renderStatus = (rowData) => {
      let statusKey = Object.keys(CheckStatus).filter(key => rowData.status.startsWith(key))?.[0];
      // const status = rowData.status.replace(/Voided/i, "<span style='color: red'><strong>Attention Needed</strong></span>")
      //   .replace(/(reissued|issued|cashed)/i, "<span style='color: #118847'><strong>$1</strong></span>")
      //   .replace(/(pending)/i, "<strong>$1</strong>")
      //   .replace(/(Payment in Queue|wip)/i, "<strong>Payment in Queue</strong>");
      const status = CheckStatus[statusKey]?.[this.props.isEng ? 'en' : 'fr'];
      return (
        <>
          {status && (
            <div
              style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{ __html: status.title + '<br/>' + status.description }}
            />
          )}
          {!status && (
            <div
              style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{ __html: rowData.status }}
            />
          )}
        </>
        
      );
    };

    const renderAddress = (rowData) => {
      return (
        <div
          style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
          dangerouslySetInnerHTML={{ __html: rowData.address }}
        />
      );
    };

    const amountTemplate = (rowData) => {
      return `$${rowData.amount.toFixed(2)}`; // Ensures two decimal places
    };

    const paymentTypeTemplate = (rowData) => {
      return (
        <div>
          {this.props.isEng ? rowData.payeeType : rowData.payeeType?.replace(/(Child)/g, "Enfant").replace(/child/g, "enfant").replace(/Adult/g, "Adulte").replace(/adult/g, "adulte").replace("Banking Fees","Frais bancaires")}
        </div>
      );
    };
    


    const tableHeader = (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="icon-container">
          <span>{this.props.isEng ? 'Payment information' : 'Renseignements sur le paiement'}</span>
          {this.state.isHovered && (
            <div className="popup" id="tooltip-payment-info" role="tooltip">
              {this.props.isEng && <span>You can find the eligibility and calculation from <a href="https://www.ontario.ca/page/ontario-taxpayer-rebate" target="_blank" rel="noopener noreferrer">the Ontario Taxpayer Rebate Program</a></span>}
              {!this.props.isEng && <span>Vous pouvez consulter les critères d’admissibilité et les <a href="https://www.ontario.ca/fr/page/remise-aux-contribuables-de-lontario" target="_blank" rel="noopener noreferrer">calculs du programme de remise aux contribuables de l’Ontario</a></span>}
            </div>
          )}
        </div>
        <button aria-labelledby="tooltip-title tooltip-payment-info" style={{border: 'none', backgroundColor: '#E5E5E5'}}>
          <svg id={`alert-info-icon-${this.props.field.Id}`}
            className="ontario-icon"
            aria-hidden="true" 
            focusable="false" 
            viewBox="0 0 24 24" 
            preserveAspectRatio="xMidYMid meet"
            role="img" 
            onMouseEnter={this.handleMouseEnter}
            //  onMouseLeave={this.handleMouseLeave}
          >
            <title id="tooltip-title">More information about Payment Information</title>
            <use href="#ontario-icon-alert-information"></use>
          </svg>
        </button>
      </div>
    );

    const root = getRootComponent(this.props.field);
    console.log("No data to display in the table.", this.props.field.Value?.length);
    
    if (root.CategoryId.toUpperCase() !== 'OTRIS' && !this.props.field.Value?.length) {
      return null;
    }
    
    return (
      <>
        <div>
          <LiveValidationErrMsg
            field={this.props.field}
            isEng={this.props.isEng}
            key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />

        </div>

        <div className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
          <div className="ontario-table-div" style={{overflowX: "visible"}}>
              {root.CategoryId.toUpperCase() === 'OTRIS' && (
                <DataTable value={this.props.field.Value} showGridlines header={tableHeader} id={`data-table-${this.props.field.Id}`}>
                  <Column header={this.props.isEng ? 'Payment type' : 'Type de paiement'} body={paymentTypeTemplate}></Column>
                  <Column header={this.props.isEng ? "Cheque amount" : 'Montant du chèque'} body={amountTemplate} />
                  <Column header={this.props.isEng ? "Status" : 'État'} body={renderStatus} />
                  <Column header={this.props.isEng ? "Mailing address" : 'Adresse postale'} body={renderAddress} />
                </DataTable>
              )}
              { root.CategoryId.toUpperCase() !== 'OTRIS' && (
                <IRPStatusTable field={this.props.field} lang={this.props.isEng ? 'en' : 'fr'} />
              )}
          </div>
        </div>  
        </>

    )
  }
}